import { render } from "./CostingTyreDetailModal.vue?vue&type=template&id=e1682582"
import script from "./CostingTyreDetailModal.vue?vue&type=script&lang=js"
export * from "./CostingTyreDetailModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__